import React from "react";

export const HomeIcon = ({
  height = "24px",
  width = "24px",
  color,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24px"
    height="24px"
  >
    {" "}
    <path d="M 12 2 A 1 1 0 0 0 11.289062 2.296875 L 1.203125 11.097656 A 0.5 0.5 0 0 0 1 11.5 A 0.5 0.5 0 0 0 1.5 12 L 4 12 L 4 20 C 4 20.552 4.448 21 5 21 L 9 21 C 9.552 21 10 20.552 10 20 L 10 14 L 14 14 L 14 20 C 14 20.552 14.448 21 15 21 L 19 21 C 19.552 21 20 20.552 20 20 L 20 12 L 22.5 12 A 0.5 0.5 0 0 0 23 11.5 A 0.5 0.5 0 0 0 22.796875 11.097656 L 12.716797 2.3027344 A 1 1 0 0 0 12.710938 2.296875 A 1 1 0 0 0 12 2 z" />
  </svg>
);

export const SearchIcon = ({
  height = "24px",
  width = "24px",
  color,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.23052 18.4263L5.65684 14C6.19194 14.8637 6.91446 15.5863 7.77817 16.1213L3.35183 20.5476C3.01257 20.8869 2.58597 21.0756 2.17112 21.1063C1.75626 21.1371 1.35307 21.0099 1.06065 20.7175C0.777303 20.4342 0.638976 20.0398 0.67106 19.6071C0.703145 19.1744 0.901804 18.755 1.23052 18.4263Z"
      fill={color}
    />
    <path
      d="M13.5 17C18.1869 17 22 13.1869 22 8.5C22 3.81308 18.1869 0 13.5 0C8.81308 0 5 3.81308 5 8.5C5 13.1869 8.81308 17 13.5 17ZM7.61622 8.5C7.61622 5.25567 10.2557 2.61622 13.5 2.61622C16.7443 2.61622 19.3838 5.25567 19.3838 8.5C19.3838 11.7443 16.7443 14.3838 13.5 14.3838C10.2557 14.3838 7.61622 11.7443 7.61622 8.5Z"
      fill={color}
    />
    <path
      d="M13.5 13C15.9853 13 18 10.9853 18 8.5C18 6.01472 15.9853 4 13.5 4C11.0147 4 9 6.01472 9 8.5C9 10.9853 11.0147 13 13.5 13Z"
      fill={color}
    />
  </svg>
);

export const RidesIcon = ({
  height = "24px",
  width = "24px",
  color = "#353F47",
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.963 12.8417H3.05C2.4701 12.8417 2 13.3118 2 13.8917V22.2917C2 22.8716 2.4701 23.3417 3.05 23.3417H21.963C21.9544 23.2832 21.95 23.2233 21.95 23.1624C21.95 22.5444 22.4061 22.0329 23 21.9461V20.7933C22.4061 20.7065 21.95 20.1951 21.95 19.577C21.95 18.959 22.4061 18.4475 23 18.3607V17.5153C22.4061 17.4285 21.95 16.917 21.95 16.299C21.95 15.681 22.4061 15.1695 23 15.0827V14.2372C22.4061 14.1505 21.95 13.639 21.95 13.0209C21.95 12.9601 21.9544 12.9002 21.963 12.8417ZM7.775 14.583C8.06495 14.583 8.3 14.3479 8.3 14.058C8.3 13.768 8.06495 13.533 7.775 13.533C7.48505 13.533 7.25 13.768 7.25 14.058C7.25 14.3479 7.48505 14.583 7.775 14.583ZM8.3 16.1579C8.3 16.4479 8.06495 16.6829 7.775 16.6829C7.48505 16.6829 7.25 16.4479 7.25 16.1579C7.25 15.868 7.48505 15.6329 7.775 15.6329C8.06495 15.6329 8.3 15.868 8.3 16.1579ZM7.775 18.7829C8.06495 18.7829 8.3 18.5479 8.3 18.2579C8.3 17.968 8.06495 17.7329 7.775 17.7329C7.48505 17.7329 7.25 17.968 7.25 18.2579C7.25 18.5479 7.48505 18.7829 7.775 18.7829ZM8.3 20.3579C8.3 20.6479 8.06495 20.8829 7.775 20.8829C7.48505 20.8829 7.25 20.6479 7.25 20.3579C7.25 20.068 7.48505 19.8329 7.775 19.8329C8.06495 19.8329 8.3 20.068 8.3 20.3579ZM7.775 22.983C8.06495 22.983 8.3 22.7479 8.3 22.458C8.3 22.168 8.06495 21.933 7.775 21.933C7.48505 21.933 7.25 22.168 7.25 22.458C7.25 22.7479 7.48505 22.983 7.775 22.983Z"
      fill={color}
    />
    <circle cx="21" cy="4" r="4" fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.21 2.42054C15.0844 2.34884 14.968 2.25597 14.8663 2.14222C14.8208 2.0914 14.7799 2.03813 14.7433 1.98291L3.77515 11.7916H21.4148L22.5818 10.748C22.531 10.7055 22.4826 10.6588 22.4371 10.608C22.2522 10.4013 22.1413 10.1541 22.1024 9.89894C21.745 9.9653 21.3765 10 20.9999 10C17.6862 10 14.9999 7.31371 14.9999 4C14.9999 3.45336 15.073 2.92379 15.21 2.42054Z"
      fill={color}
    />
  </svg>
);

export const ProfileIcon = ({
  height = "24px",
  width = "24px",
  color = "#353F47",
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9.08004" cy="5.87997" r="5.04" fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4799 20.1102H0.680176C0.707 15.4939 4.45747 11.76 9.08003 11.76C13.7026 11.76 17.4531 15.4939 17.4799 20.1102Z"
      fill={color}
    />
  </svg>
);

export const LoyalityIcon = ({
  height = "24px",
  width = "24px",
  color = "#353F47",
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.76923 17.5385C13.6123 17.5385 17.5385 13.6123 17.5385 8.76923C17.5385 3.92612 13.6123 0 8.76923 0C3.92612 0 0 3.92612 0 8.76923C0 13.6123 3.92612 17.5385 8.76923 17.5385ZM8.76922 15.6923C12.5927 15.6923 15.6923 12.5927 15.6923 8.76923C15.6923 4.94572 12.5927 1.84615 8.76922 1.84615C4.94571 1.84615 1.84614 4.94572 1.84614 8.76923C1.84614 12.5927 4.94571 15.6923 8.76922 15.6923Z"
      fill={color}
    />
    <circle cx="8.76929" cy="8.76929" r="6" fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.69226 17.0271V24H13.8461L13.8461 24L13.8461 17.0271C12.3696 17.9368 10.6307 18.4616 8.76918 18.4616C6.90768 18.4616 5.16875 17.9368 3.69226 17.0271ZM13.8461 24H3.69227L8.76919 19.9385L13.8461 24Z"
      fill={color}
    />
  </svg>
);

export const LogoutIcon = ({
  height = "24px",
  width = "24px",
  color = "#353F47",
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.6099 14.61L21.4799 9.45001C21.15 9.12001 20.6099 9.36001 20.6099 9.87001V13.2H13.83C13.47 13.2 13.2 13.5 13.2 13.83V16.11C13.2 16.47 13.5 16.74 13.83 16.74H20.6099V20.1C20.6099 20.58 21.15 20.82 21.4799 20.49L26.6099 15.36C26.8199 15.18 26.8199 14.82 26.6099 14.61Z"
      fill={color}
    />
    <path
      d="M17.1 20.8799H8.30996C7.73996 20.8799 7.28996 20.4299 7.28996 19.8599V10.1399C7.28996 9.56995 7.73996 9.11995 8.30996 9.11995H17.1C17.4 9.11995 17.64 8.87995 17.64 8.57995V5.60995C17.64 5.30995 17.4 5.06995 17.1 5.06995H4.49996C3.80996 5.06995 3.20996 5.57995 3.20996 6.20995V23.8199C3.20996 24.4499 3.77996 24.9599 4.49996 24.9599H17.1C17.4 24.9599 17.64 24.7199 17.64 24.4199V21.4499C17.64 21.1199 17.37 20.8799 17.1 20.8799Z"
      fill={color}
    />
  </svg>
);

export const CarRental = ({
  height = "24px",
  width = "24px",
  color = "#353F47",
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enable-background="new 0 0 24 24"
    height="30px"
    viewBox="0 0 30 30"
    width="30px"
    fill={color}
  >
    <g>
      <rect fill="none" height="30" width="30" />
    </g>
    <g>
      <g>
        <path d="M16.39,9H7.61C7.18,9,6.8,9.28,6.66,9.68l-1.66,5v6.81C5,21.78,5.23,22,5.5,22h1C6.78,22,7,21.78,7,21.5V20h10v1.5 c0,0.28,0.22,0.5,0.5,0.5h1c0.28,0,0.5-0.22,0.5-0.5v-6.81l-1.66-5C17.2,9.28,16.82,9,16.39,9z M7.78,18 c-0.68,0-1.22-0.54-1.22-1.22s0.54-1.22,1.22-1.22S9,16.11,9,16.78S8.46,18,7.78,18z M16.22,18C15.55,18,15,17.46,15,16.78 s0.54-1.22,1.22-1.22s1.22,0.54,1.22,1.22S16.9,18,16.22,18z M6.29,14l1.33-4h8.78l1.33,4H6.29z" />
        <path d="M10.83,3C10.41,1.83,9.3,1,8,1C6.34,1,5,2.34,5,4c0,1.65,1.34,3,3,3c1.3,0,2.41-0.84,2.83-2H16v2h2V5h1V3H10.83z M8,5 C7.45,5,7,4.55,7,4s0.45-1,1-1s1,0.45,1,1S8.55,5,8,5z" />
      </g>
    </g>
  </svg>
);

export const HelpIcon = ({
  color = "#353F47",
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM7.41 4.62C8.06 4.08 8.92 3.8 9.97 3.8C10.51 3.8 11 3.88 11.45 4.05C11.89 4.22 12.28 4.44 12.59 4.73C12.91 5.02 13.15 5.36 13.33 5.75C13.5 6.14 13.59 6.57 13.59 7.02C13.59 7.47 13.51 7.89 13.35 8.25C13.19 8.62 12.95 8.98 12.64 9.36L11.43 10.94C11.29 11.11 11.15 11.27 11.11 11.42C11.06 11.57 11 11.77 11 12.02V12.45C11 12.57 11 12.99 11 12.99H9V10.99C9 10.99 9.06 10.41 9.24 10.18L10.45 8.54C10.7 8.24 10.86 7.98 10.96 7.77C11.06 7.56 11.1 7.33 11.1 7.1C11.1 6.75 10.99 6.47 10.78 6.25C10.57 6.03 10.28 5.92 9.9 5.92C9.53 5.92 9.23 6.03 9.01 6.25C8.79 6.48 8.64 6.79 8.55 7.19C8.52 7.31 8.44 7.36 8.32 7.35L6.37 7.06C6.25 7.05 6.21 6.98 6.23 6.84C6.36 5.91 6.75 5.17 7.41 4.62ZM9 14H11.02L11 16H9V14Z" fill={color}/>
</svg>

);

export const AboutUsIcon = ({
  color = "#353F47",
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.94 15C16.88 14.67 16.77 14.31 16.61 13.94C16.16 12.97 15.24 12.42 13.37 11.64C13.2 11.57 12.61 11.33 12.6 11.32C12.5 11.28 12.4 11.24 12.32 11.2C12.37 11.06 12.36 10.91 12.38 10.75C12.38 10.7 12.39 10.64 12.39 10.59C12.14 10.38 11.92 10.11 11.74 9.8C11.96 9.46 12.15 9.09 12.3 8.68L12.34 8.57C12.33 8.59 12.33 8.59 12.32 8.65C12.34 8.6 12.36 8.55 12.38 8.5C12.74 8.24 12.98 7.83 13.1 7.37C13.28 7 13.39 6.55 13.35 6.07C13.3 5.57 13.14 5.15 12.88 4.85C12.86 4.32 12.82 3.74 12.76 3.26C13.14 3.09 13.59 3 14 3C14.59 3 15.26 3.19 15.73 3.55C16.19 3.9 16.53 4.4 16.7 4.95C16.74 5.08 16.77 5.2 16.78 5.33C16.86 5.78 16.91 6.47 16.91 6.94C16.91 6.96 16.91 6.99 16.91 7.01C17.07 7.08 17.22 7.25 17.26 7.63C17.28 7.92 17.17 8.18 17.11 8.28C17.06 8.54 16.91 8.81 16.65 8.87C16.62 8.99 16.58 9.12 16.54 9.23C16.53 9.24 16.53 9.27 16.53 9.27C16.33 9.8 16.02 10.27 15.64 10.61C15.64 10.67 15.64 10.73 15.65 10.78C15.69 11.19 15.54 11.49 16.65 11.97C17.75 12.47 19.42 12.98 19.78 13.76C20.12 14.55 19.98 15.01 19.98 15.01H16.94V15ZM11.52 11.94C12.99 12.6 15.22 13.29 15.7 14.33C16.15 15.38 15.97 16 15.97 16H0.0399819C0.0399819 16 -0.150018 15.38 0.309982 14.33C0.769982 13.28 2.98998 12.58 4.46998 11.93C5.94998 11.28 5.79998 10.88 5.84998 10.34C5.84998 10.27 5.85998 10.2 5.85998 10.13C5.33998 9.68 4.90998 9.05 4.63998 8.33L4.62998 8.32C4.62998 8.31 4.61998 8.3 4.61998 8.29C4.54998 8.14 4.49998 7.97 4.45998 7.8C4.11998 7.74 3.91998 7.37 3.83998 7.02C3.75998 6.88 3.59998 6.54 3.63998 6.15C3.68998 5.64 3.89998 5.41 4.12998 5.32C4.12998 5.29 4.12998 5.27 4.12998 5.24C4.12998 4.6 4.17998 3.69 4.29998 3.09C4.31998 2.92 4.35998 2.75 4.40998 2.59C4.62998 1.85 5.08998 1.19 5.69998 0.73C6.31998 0.25 7.20998 0 7.99998 0C8.78998 0 9.67998 0.25 10.31 0.73C10.93 1.19 11.38 1.86 11.6 2.59C11.65 2.76 11.69 2.92 11.71 3.09C11.82 3.69 11.88 4.61 11.88 5.24C11.88 5.27 11.88 5.3 11.88 5.33C12.1 5.42 12.3 5.65 12.35 6.15C12.38 6.54 12.23 6.88 12.15 7.02C12.08 7.36 11.88 7.73 11.54 7.8C11.5 7.96 11.45 8.13 11.39 8.28C11.38 8.29 11.37 8.33 11.37 8.33C11.1 9.04 10.69 9.66 10.18 10.11C10.18 10.19 10.18 10.27 10.19 10.34C10.24 10.89 10.04 11.29 11.52 11.94Z" fill={color}/>
</svg>

);
